<template lang="pug">
article-item-page-template(:title="pageTitle", :loading="loading")
  template(#header)
    .text-h6(v-html="content.title")
  template(#main)
    v-img.rounded.bordered.mb-2(
      :src="files + '/' + content.mainImg",
      max-height="400px",
      contain
    )
    .ck-content(v-html="content.text")
    images.mt-3(
      v-if="content.imgs && content.imgs.length > 0",
      :items="content.imgs"
    )
    videos.mt-3(
      v-if="content.videos && content.videos.length > 0",
      :items="content.videos"
    )
  template(#side)
    communications-widget
</template>

<script>
import ArticleItemPageTemplate from "@/components/templates/ArticleItemPage";
import CommunicationsWidget from "@/components/widgets/Communications";
import Images from "@/components/sections/Images";
import Videos from "@/components/sections/Videos";

export default {
  data: () => ({
    loading: false,
  }),
  computed: {
    pageTitle() {
      return this.$route.meta.title;
    },
    mod() {
      return this.$route.meta.mod;
    },
    itemId() {
      const item = this.$route.params.item;
      return item ? item.replace(/^.*-([0-9]+)$/, "$1") : null;
    },
    content() {
      return this.$rest(this.mod).item;
    },
    sm() {
      return this.$vuetify.breakpoint.smAndDown;
    },
  },
  methods: {
    getContent() {
      this.loading = true;

      const options = { save: (state, data) => (state.item = data) };
      if (this.itemId) options.id = this.itemId;

      this.$rest(this.mod)
        .get(options)
        .then(() => (this.loading = false))
        .catch(() => {
          this.$router.replace("/error404");
        });
    },
  },
  created() {
    this.getContent();
  },
  watch: {
    $route() {
      this.getContent();
    },
  },
  components: {
    ArticleItemPageTemplate,
    CommunicationsWidget,
    Images,
    Videos,
  },
};
</script>
